import { GoogleDocLegalPage } from './legal/GoogleDocLegalPage';
import { LEGAL_DOCUMENTS } from './legal/legalDocuments';

export const ServicesAgreement = () => (
  <GoogleDocLegalPage document={LEGAL_DOCUMENTS.servicesAgreement} />
);
